import {
  LOG_IN,
  LOG_OUT,
  USER_DETAIL,
  LOGIN_SUCCESFULL,
  LOGIN_FAIL,
  CLEAR_STATE,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAIL,
} from "../Action/auth";

const initialState = {
  token: localStorage.getItem("usertoken"),
  isAuthenticated: null,
  userDetail: "",
  loginSuccess: "",
  loginFail: "",
  getUserDetailSuccess: "",
  getUserDetailFail: "",
};

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case LOG_IN: {
      const { result, token } = action.payload;
      console.log("authToken at login call", token);
      localStorage.setItem("usertoken", token);
      return { ...state, userDetail: result };
    }

    case LOGIN_SUCCESFULL: {
      return { ...state, loginSuccess: "Login Successfull" };
    }
    case LOGIN_FAIL: {
      return { ...state, loginFail: action.payload };
    }

    case GET_CURRENT_USER_SUCCESS: {
      let { result, message } = action.payload;
      return { ...state, userDetail: result, getUserDetailSuccess: message };
    }
    case GET_CURRENT_USER_FAIL: {
      return { ...state, getUserDetailFail: action.payload };
    }

    case USER_DETAIL: {
      return { ...state, users: action.payload };
    }

    case LOG_OUT: {
      localStorage.removeItem("usertoken");
      return { ...state, users: "" };
    }

    case CLEAR_STATE: {
      return {
        ...state,
        loginSuccess: "",
        loginFail: "",
        getUserDetailSuccess: "",
        getUserDetailFail: "",
      };
    }

    default:
      return state;
  }
}

export default accountReducer;
